/* @flow */
import workflow from './workflow';
import { release } from 'ducks/workflow';
import ReleaseButton from 'components/buttons/workflow/ReleaseButton';

export default workflow({action: release})(ReleaseButton);
